/**
 * Privacy JS controller.
 *
 * This class handles controlling of privacy policy.
 * Basically this means that profiling can be disabled
 * or enabled with this class.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Privacy. This gets mapped with the keyword Privacy and its
 * docready method is fired automatically on pages where there's a
 * class called 'Privacy' on the html tag.
 */
class Privacy {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        this.profilingInfoContainer = $( '#js-profiling-text-container' );
        this.enableProfilingButton  = $( '#js-enable-profiling' );
        this.disableProfilingButton = $( '#js-disable-profiling' );
        this.profilingEnabledText   = $( '#js-profiling-enabled' );
        this.profilingDisabledText  = $( '#js-profiling-disabled' );
        this.disableProfiling       = 0;
    }

    /**
     * Here we define all events of the class.
     */
    events() {

        $( this.enableProfilingButton ).on( 'click', ( e ) =>  {
            this.disableProfiling = 0;
            this.controlProfiling( e );
            this.profilingInfoContainer.focus();
        });

        $( this.disableProfilingButton ).on( 'click', ( e ) =>  {
            this.disableProfiling = 1;
            this.controlProfiling( e );
            this.profilingInfoContainer.focus();
        });

    }

    /**
     * This controls the localStorage value which is used as the base
     * for profiling calculations.
     */
    controlProfiling() {

        localStorage.setItem( 'disableProfiling', this.disableProfiling );
        this.assertProfiling();
    }

    /**
     * This checks whether profiling is enabled and shows an according text
     * to the user on the Privacy policy page.
     */
    assertProfiling() {

        const localStorageprofilingDisabled = localStorage.getItem( 'disableProfiling' );

        if ( localStorageprofilingDisabled == 1 ) {
            this.profilingEnabledText.addClass( 'js-hidden' );
            this.profilingDisabledText.removeClass( 'js-hidden' );

            localStorage.removeItem( 'profiling' );

        } else {
            this.profilingEnabledText.removeClass( 'js-hidden' );
            this.profilingDisabledText.addClass( 'js-hidden' );
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.assertProfiling();
    }
}

// Export the class reference.
module.exports = Privacy;



// WEBPACK FOOTER //
// ./assets/scripts/privacy.js